import React, { useContext } from 'react'
import { Text, View } from 'oio-react'
import { Link } from 'react-router-dom'
import { initiativeUrl } from 'config/constants/urls'
import { InitiativeHierarchyContext } from 'src/sites/kits/Utils/InitiativeHierarchy'

const InitiativeSettingsPages = () => {
   const { initiative } = useContext(InitiativeHierarchyContext)

   return (
      <View width="100%">
         <View
            width="100%"
            maxWidth="100%[a-c] 660px[d-f]"
            padding="20px[a] 25px[b] 30px[c] 40px[d-f]">
            <Text size="5" lineHeight="150%" color="#222">
               {`${initiative.type.nameSingular} Menu & Pages`}
            </Text>
            <br />
            <View display="flex">
               <View flex="1 1 auto" paddingRight="20px">
                  <Text size="2" lineHeight="150%" color="#666">
                     {`Hey there 👋, the settings for adding and editing pages for ${initiative.type.namePlural} have moved!`}
                     <br />
                     <br />
                     {'On the '}
                     <Link to={initiativeUrl(initiative)} style={{ color: '#222' }}>
                        <u>{`${initiative.type.namePlural} page`}</u>
                     </Link>
                     {', look for the "plus" (+) button to add a new page, and click on the "three-dot" (...) button to find more page-specific settings (including the ability to edit and remove that page).'}
                     <br />
                     <br />
                     {'If you are having issues or need help, please don\'t hesitate to reach out to '}
                     <a href="mailto:support@mother.co">
                        <u style={{ color: '#222' }}>support@mother.co</u>
                     </a>
                  </Text>
               </View>
               <View
                  flex="0 0 auto"
                  width="200px"
                  height="200px"
                  borderRadius="6px"
                  backgroundSize="cover"
                  backgroundPosition="center center"
                  backgroundImage="url(/assets/images/helpers/page-settings-helper-2.jpg)"
               />
            </View>
            <View
               marginTop="20px"
               width="100%"
               paddingTop="50%"
               borderRadius="6px"
               backgroundSize="cover"
               backgroundImage="url(/assets/images/helpers/page-settings-helper-1.jpg)"
            />
         </View>
      </View>
   )
}

export default InitiativeSettingsPages
